// src/pages/PreviousPapers.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchPapers, downloadPaper } from "../api";

export default function PreviousPapers() {
  const navigate = useNavigate();
  const [papers, setPapers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPapers()
      .then(d => { setPapers(d); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  const handleMock = (paper) => {
    // Navigate to test session with specific config for this paper
    sessionStorage.setItem("testConfig", JSON.stringify({
      testType: "mock",
      subject: "", // Clear subject to avoid filter conflicts with tags
      tag: paper.title, // e.g. "SBI PO Prelims 2023"
      limit: paper.totalQuestions
    }));
    navigate("/test/session");
  };

  const handleDownload = async (id) => {
    try {
      const res = await downloadPaper(id);
      window.open(res.url, "_blank");
    } catch (e) {
      alert("Download failed: " + e.message);
    }
  };

  if (loading) return <div className="loading"><div className="spinner" /><span>Loading papers…</span></div>;

  return (
    <div className="fade-in">
      <h1 className="page-title">Previous Years Questions Packs</h1>
      <p className="page-sub">Practice with real exam questions from past years to understand the difficulty level</p>

      <div style={{ marginTop: 24, display: "flex", flexDirection: "column", gap: 12 }}>
        {papers.map(p => (
          <div key={p.id} className="practice-row" style={{ justifyContent: "space-between" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
              <div style={{ 
                width: 44, height: 44, borderRadius: 10, background: "var(--blue-bg)", 
                display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18 
              }}>📄</div>
              <div>
                <div style={{ fontSize: 14, fontWeight: 700, color: "var(--text-primary)" }}>{p.title}</div>
                <div style={{ fontSize: 12, color: "var(--text-muted)" }}>
                  {p.exam} &middot; {p.year} &middot; {p.totalQuestions} Questions &middot; {p.duration} Mins
                </div>
              </div>
            </div>

            <div style={{ display: "flex", gap: 10 }}>
              <button 
                className="btn btn-sm" 
                onClick={() => handleDownload(p.id)}
                style={{ borderRadius: 8 }}
              >
                📥 Download
              </button>
              <button 
                className="btn btn-sm btn-blue" 
                onClick={() => handleMock(p)}
                style={{ borderRadius: 8 }}
              >
                Take Mocktest
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
